import { useEffect } from 'react';

/**
 * Hook to dynamically set the breadcrumb title for a detail page.
 * Dispatches an event that GlobalBreadcrumbs listens to.
 * 
 * @param {string|null} title - The title to display in the breadcrumb, or null to clear it.
 */
export function useBreadcrumbTitle(title) {
   useEffect(() => {
      if (title) {
         window.dispatchEvent(new CustomEvent('set-breadcrumb-title', { detail: title }));
      }
      return () => {
         window.dispatchEvent(new CustomEvent('set-breadcrumb-title', { detail: null }));
      };
   }, [title]);
}
